import { useIntl, type UserAmlQuestionnaireUserProvidedValuesSpendingEstimatePerYear } from '@capsicum/common';
import { amlQuestionnaireReducerAtom } from '@capsicum/features/regulations/shared';
import { useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';

type SpendingEstimateOption = {
	id: UserAmlQuestionnaireUserProvidedValuesSpendingEstimatePerYear;
	label: string;
};

export const useAmlSpendingEstimate = () => {
	const { $t } = useIntl();
	const [selectedOption, setSelectedOption] = useState<
		undefined | UserAmlQuestionnaireUserProvidedValuesSpendingEstimatePerYear
	>(undefined);
	const dispatch = useSetAtom(amlQuestionnaireReducerAtom);

	const options: Array<SpendingEstimateOption> = [
		{
			id: 'less_than_1K',
			label: $t('amlQuestionnaire.spendingEstimateStep.less_than_1K')
		},
		{
			id: 'between_1K_and_10K',
			label: $t('amlQuestionnaire.spendingEstimateStep.between_1K_and_10K')
		},
		{
			id: 'between_10K_and_40K',
			label: $t('amlQuestionnaire.spendingEstimateStep.between_10K_and_40K')
		},
		{
			id: 'more_than_40K',
			label: $t('amlQuestionnaire.spendingEstimateStep.more_than_40K')
		}
	];

	useEffect(() => {
		if (!selectedOption) return;

		dispatch({ isValid: true, stepId: 'SpendingEstimatePerYear', type: 'UPDATE_STEP_VALIDITY' });
		dispatch({ data: { spendingEstimatePerYear: selectedOption }, type: 'UPDATE_FORM_DATA' });
	}, [selectedOption]);

	return {
		options,
		selectedOption,
		setSelectedOption
	};
};
